import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 匿名聊天首页`,
    languageButtonLabel: `语言`,
    languageModalTitle: `选择语言`,
    languageModalCloseLabel: `关闭语言菜单`,
  },
  languageOptions: {
    'en-US': {
      label: `英语 (美国)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `英语 (肯尼亚)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `英语 (尼日利亚)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `英语 (新加坡)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `葡萄牙语 (葡萄牙)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `葡萄牙语 (巴西)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `德语 (德国)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `德语 (奥地利)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `德语 (瑞士)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `西班牙语 (西班牙)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `法语 (法国)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `意大利语 (意大利)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `荷兰语 (荷兰)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `波兰语 (波兰)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `瑞典语 (瑞典)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `丹麦语 (丹麦)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `芬兰语 (芬兰)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `挪威语 (挪威)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `冰岛语 (冰岛)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日语 (日本)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `韩语 (韩国)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `中文 (中国)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `粤语 (中国香港特别行政区)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `越南语 (越南)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `泰语 (泰国)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `印度尼西亚语 (印度尼西亚)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `斯瓦希里语 (肯尼亚)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `印地语 (印度)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `孟加拉语 (孟加拉国)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `马拉地语 (印度)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `泰卢固语 (印度)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `波斯语 (伊朗)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `乌尔都语 (巴基斯坦)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `旁遮普语 (巴基斯坦)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `尼日利亚皮钦语 (尼日利亚)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `俄语 (俄罗斯)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `阿拉伯语 (沙特阿拉伯)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `阿拉伯语 (阿拉伯联合酋长国)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `阿拉伯语 (卡塔尔)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `摩洛哥阿拉伯语`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `土耳其语 (土耳其)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `选择语言`,
    closeLabel: `关闭语言菜单`,
  },
  languageHint: (ctx) => `无需账号即可切换 ${ctx.localesCount}+ 种语言。`,
  readPagePrompt: ({languageLabel}) => `用${languageLabel}阅读此页面。`,
};
